import "lazysizes"
import "picturefill"
// var $ = require('jQuery');

//アコーディオン
$('.js-menu__item__link').each(function () {
  $(this).on('click', function () {
    $("+.system__box,+.system__box--s,+.que__box", this).slideToggle();
    $(this).toggleClass("is-active")
    return false;
  });
});

//ヘッダーメニュー
$('.header__btn').on('click', function () {
  $('html').toggleClass('scroll-prevent')
  if ($(this).hasClass('is-active')) {
    $(this).removeClass('is-active');
    $('#nav-list').slideUp();
  } else {
    $(this).addClass('is-active');
    $('#nav-list').slideDown();
  }
})

$(".faq__item__q").each(function () {
  $(this).on("click", function () {
    $("+div", this).slideToggle();
    $(this).toggleClass("is-active");
    return false;
  });
});

// スムーススクロール
$('a[href^="#"]').click(function () {
  const speed = 500;
  const href = $(this).attr("href");
  const target = $(href == "#" || href == "" ? "html" : href);
  const position = target.offset().top;
  $("html, body").animate({ scrollTop: position }, speed, "swing");
  return false;
});